import * as React from 'react';
import { ContainerEmailPreview } from './ContainerEmailPreview';
import { CaseType, DocumentActivePhase } from '@/interfaces';

interface DemandComplaintPreviewI {
	caseName: string;
	caseType?: CaseType;
	type: 'complaint' | 'demand letter';
	caseDocuments: DocumentActivePhase[] | undefined;
}

export const DemandComplaintPreview: React.FC<DemandComplaintPreviewI> = ({
	caseName,
	type,
	caseType,
	caseDocuments,
}) => {
	const [htmlContent, setHtmlContent] = React.useState<string>('');
	const [stylesContent, setStylesContent] = React.useState<string>('');

	const getFileName = () => {
		if (caseDocuments && caseType) {
			const documentsArray = caseDocuments.map((item) =>
				item.document_type.toLowerCase()
			);
			if (
				documentsArray.includes('demand letter') &&
				caseType === 'CLASS_ACTION' &&
				type === 'complaint'
			) {
				return 'case-update-review-complaint';
			} else if (
				documentsArray.includes('complaint') &&
				caseType === 'MASS_ACTION' &&
				type === 'demand letter'
			) {
				return 'case-update-review-demand-letter';
			} else if (type === 'demand letter') {
				return 'review-demand-letter';
			} else {
				return 'review-complaint';
			}
		}
	};

	React.useEffect(() => {
		const fetchHtml = async () => {
			// Get the content of the HTML file
			const response = await fetch(
				`/email-templates/client/${getFileName()}.html`
			);
			const html = await response.text();

			// Create a DOM to render the content
			const parser = new DOMParser();
			const doc = parser.parseFromString(html, 'text/html');

			// Extraer el div con id="principalContent"
			const contentElement = doc.querySelector('#principalContent');

			if (contentElement) {
				// Replace [Case Name]
				contentElement.innerHTML = contentElement.innerHTML.replace(
					'[Case Name]',
					caseName
				);

				// Deshabilitar todos los enlaces <a> y aplicar estilos
				const links = doc.querySelectorAll('a');
				links.forEach((link) => {
					link.removeAttribute('href'); // Eliminar funcionalidad del enlace
					link.style.opacity = '0.7'; // Reducir opacidad
					link.style.pointerEvents = 'none'; // Deshabilitar clics
					link.style.cursor = 'not-allowed'; // Mostrar cursor deshabilitado
				});
			}
			setHtmlContent(contentElement?.outerHTML || '');

			// Extract styles from file
			const styleElements = doc.querySelectorAll('style');
			let extractedStyles = '';
			styleElements.forEach((style) => {
				extractedStyles += style.textContent;
			});
			setStylesContent(extractedStyles);
		};

		fetchHtml();
	}, []);

	return (
		<ContainerEmailPreview type="email">
			{/* Inject the extracted styles and add flex so it looks good in preview */}
			<style>
				{`
					${stylesContent}
					.centerAlign {
						text-align: center;
						margin: 0 auto 0 auto;
						display: flex;
						flex-direction: column;
						align-items: center;
						justify-content: center;
					}
				`}
			</style>
			<div
				className="mb-10"
				dangerouslySetInnerHTML={{ __html: htmlContent }}
			/>
		</ContainerEmailPreview>
	);
};
